import React, { useEffect, useState, } from 'react'
import { useParams } from 'react-router';

import axios from 'axios';
import useAuth from '../../controllers/users/useAuth';

import {
    checkIfCallPrinterAsync, responseGet, globalSettings, separatorsNumbersSet, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, statusByNumberGet, awaitDelay, isUndNullEmp,
    languageObjGet, LoadingSection,
} from '../../helpers/settings';
import HtmlParser from 'react-html-parser';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'ElectionPreviousResultsPrint';

const { app, icons, labels, messages, } = globalSettings;
const { backend, } = app;

export default function ElectionPreviousResultsPrint({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region others
    let result;
    //let dataObj = {};
    let headerObj = {};
    const { id, } = useParams();
    const auth = useAuth();
    const [showLoading, setShowLoading] = useState(true);
    const [dataGlobal, setDataGlobal] = useState({ apartmentTotals: 0, apartmentVotesPercentage: 0.00, apartmentVotesPercentageHtml: '', isResumen: false, });
    //#endregion others

    //#region building
    const [building, setBuilding] = useState({});
    //#endregion building

    //#region election
    const [election, setElection] = useState({});
    //#endregion election

    //#region election (details)
    const [electionDetails, setElectionDetails] = useState({});
    //#endregion election (details)

    //#region user
    const [user, setUser] = useState({});
    //#endregion user

    //#region methods
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.fourthySeconds, false, true, null, '');
            setShowLoading(true);

            //#region get condominium board election
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReports}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: true,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const election = response?.result;
            setElectionDetails(election?.details);

            const apartmentVotesPercentage = !isUndNullEmp({ data: election?.apartmentVotesPercentage, subMethod: currentMethod, })?.result ? election?.apartmentVotesPercentage : 0.00;
            response = await votesPercentageGetAsync({
                apartmentVotesPercentage: apartmentVotesPercentage,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: true,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setDataGlobal({
                apartmentTotals: (!isUndNullEmp({ data: election?.apartmentTotals, subMethod: currentMethod, })?.result ? election?.apartmentTotals : 0),
                //apartmentVotesPercentage: (!isUndefined(localElection.apartmentVotesPercentage) && !isNull(localElection.apartmentVotesPercentage) ? localElection.apartmentVotesPercentage : 0.00),
                apartmentVotesPercentage: apartmentVotesPercentage,
                apartmentVotesPercentageHtml: response?.result,
                isResumen: (!isUndNullEmp({ data: election?.isResumen, subMethod: currentMethod, })?.result ? election.isResumen : false),
            });
            //#endregion get condominium board election

            //#region get elections
            setElection(election?.condominiumBoardElection);
            //#endregion get election

            //#region building get
            setBuilding(election?.building);
            //#endregion building get

            //#region user get
            setUser(election?.user);
            //#endregion building get

            //#region show printer promp
            response = await checkIfCallPrinterAsync({
                checkIfOnlyIsMobile: false,
                subMethod: currentMethod,
            });

            if (!response.isSuccess) {
                setShowLoading(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: true,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const sHowPrinterPromp = response?.result === true ? true : false;

            //setShowLoading(true);
            setShowLoading(false);

            //sendMessage(-2, '', 0, false, false, null, '');

            if (sHowPrinterPromp) {
                //await new Promise(r => setTimeout(r, globalSettings?.timers?.oneSecond));
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                window?.addEventListener('load', window?.print());
            }

            //#endregion show printer promp
        } catch (ex) {
            setShowLoading(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: true,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataDetailGet = ({ processType = 0, detail = {}, subMethod = '', }) => {
        const currentMethod = 'dataDetailGet';
        let response = responseGet();
        try {
            switch (processType) {
                case 0:
                    response.result = detail?.id;
                    break;
                case 1:
                    response.result = detail?.userFullName;
                    break;
                case 2:
                    response.result = detail?.apartmentUser?.apartment?.identifier;
                    break;
                case 3:
                    response.result = detail?.votesResults?.votes;
                    break;
                case 4:
                    response.result = detail?.condominiumBoardRole?.description;
                    break;
                case 5:
                    //response.result = detail?.votesResults?.votesPercentage;
                    response.result = !isUndNullEmp({ data: detail?.votesResults?.votesPercentage, subMethod: currentMethod, })?.result && detail?.votesResults?.votesPercentage > 0 ?
                        detail?.votesResults?.votesPercentage : null;
                    break;
                case 6:
                    response.result = !isUndNullEmp({ data: detail?.votesResults?.votesPercentage, subMethod: currentMethod, })?.result ? detail?.votesResults?.votesPercentage : 0;
                    break;
                default:
                    break;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const votesPercentageGetAsync = async ({ apartmentVotesPercentage = 0.00, subMethod = '', }) => {
        const currentMethod = 'votesPercentageGetAsync';
        let response = responseGet();
        try {
            //#region variables
            const percentage = separatorsNumbersSet({ number: apartmentVotesPercentage, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result;
            //#endregion variables

            //#region process
            if (apartmentVotesPercentage > 0.00 && apartmentVotesPercentage < 50.00) {
                //response.result = `<span class='text-danger'><b>${separatorsNumbersSet({ number: apartmentVotesPercentage, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result}%</b>`;
                response.result = `<span class='text-danger'><b>${percentage}%</b>`;
                response.result += `${globalSettings?.html?.space?.formatTwo}<i class='${icons?.caretDown}'></i>`;
                response.result += `</span>`
            } else if (apartmentVotesPercentage >= 50.00 && apartmentVotesPercentage < 75.00) {
                //response.result = `<span class='text-warning'><b>${separatorsNumbersSet({ number: apartmentVotesPercentage, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result}%</b>`;
                response.result = `<span class='text-warning'><b>${percentage}%</b>`;
                response.result += `${globalSettings?.html?.space?.formatTwo}<i class='${icons?.notEqual}'></i>`;
                response.result += `</span>`
            } else if (apartmentVotesPercentage >= 75.00) {
                //response.result = `<span class='text-success'><b>${separatorsNumbersSet({ number: apartmentVotesPercentage, withDecimals: true, consoleLogErrorShow: true, subMethod: currentMethod, })?.result}%</b>`;
                response.result = `<span class='text-success'><b>${percentage}%</b>`;
                response.result += `${globalSettings?.html?.space?.formatTwo}<i class='${icons?.caretUp}'></i>`;
                response.result += `</span>`
            }
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            {/* <div style={{margin: '3px'}}> */}
            {//showReport && !showLoading ?
                !showLoading ?
                    <div className='container mt-4'>
                        <div className='card card-outline card-secondary elevation-3 shadow-lg'>
                            <div className='card-header'>
                                <h5 className='card-title'>
                                    <img src={globalSettings?.images?.appLogo}
                                        alt='appLogo'
                                        className='brand-image img-circle elevation-3'
                                        style={styles.receiptPrintLogo} /> {globalSettings?.app?.name}

                                    <div className='text-muted' style={{ fontSize: '13px' }}>
                                        {HtmlParser(globalSettings?.html?.space?.formatSevenTeen)}{messages?.theOnlyAndBestProgramInCondominiumManagement?.[languageObj?.id]}
                                    </div>
                                </h5>

                                <div className='card-tools text-small'>
                                    <ul className='list-unstyled float-right'>
                                        <li>
                                            {`${labels?.date?.[languageObj?.id]}:`} <b>{`${dateTimeFormatGlobalSet({
                                                date: new Date(),
                                                type: languageObj?.format?.date?.f1,
                                                format: 0,
                                                addTime: false,
                                                languageId: languageObj?.id,
                                                subMethod: 'lbl - date',
                                            })?.result}`}</b>
                                        </li>
                                        <li>
                                            {`${labels?.time?.[languageObj?.id]}:`} <b>{`${dateTimeFormatGlobalSet({
                                                date: new Date(),
                                                type: '',
                                                format: languageObj?.format?.time?.type,
                                                addTime: false,
                                                languageId: languageObj?.id,
                                                subMethod: 'lbl - time',
                                            })?.result}`}</b>
                                        </li>
                                        <li>
                                            {`${labels?.user?.[languageObj?.id]}:`} <b>{!isUndNullEmp({ data: user?.displayName, subMethod: 'label - user', })?.result ?
                                                user.displayName : `${user?.firstName || ''} ${user?.lastName || ''}`}</b>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className='card-body'>
                                {/* <div className='row'> */}
                                <div className='text-center'>
                                    {/* <h6>{labels?.condominiumBoardElections?.[languageObj?.id]}</h6> */}
                                    {/* <b>({labels?.previousResults?.[languageObj?.id]})</b> */}
                                    {/* <h6><b>({labels?.previousResults?.[languageObj?.id]?.toLowerCase()})</b></h6> */}
                                    <h5>
                                        {labels?.condominiumBoardElections?.[languageObj?.id]} <br />
                                        <b>({labels?.previousResults?.[languageObj?.id]?.toLowerCase()})</b>
                                    </h5>
                                </div>
                                {/* </div> */}

                                <section className='invoice'>
                                    {/* info row */}
                                    <div className='row invoice-info'>
                                        <div className='col-sm-4 invoice-col'>
                                            <address className='mx-2'>
                                                {labels?.building?.[languageObj?.id]}: <b>{building?.description || ''}</b><br />
                                                {labels?.phone?.[languageObj?.id]}: {building?.phoneNumber || ''}<br />
                                                {labels?.address?.[languageObj?.id]}: {building?.address || ''}<br />
                                                {labels?.email?.[languageObj?.id]}: {building?.email || ''}<br />
                                                {labels?.apartments?.[languageObj?.id]}: <b>{!isUndNullEmp({ data: dataGlobal?.apartmentTotals, subMethod: currentMethod, })?.result ? separatorsNumbersSet({ number: dataGlobal?.apartmentTotals, withDecimals: false, consoleLogErrorShow: true, subMethod: currentMethod, })?.result : 0}</b><br />
                                            </address>
                                        </div>
                                        {/* /.col */}
                                        <div className='col-sm-4 invoice-col border-left'>
                                            <address>
                                                {labels?.description?.[languageObj?.id]}: <b>{election?.description || ''}</b><br />
                                                {labels?.from?.[languageObj?.id]}: <b>{`${dateTimeFormatGlobalSet({
                                                    date: election?.startDate || new Date(),
                                                    type: languageObj?.format?.date?.f1,
                                                    format: 0,
                                                    addTime: true,
                                                    languageId: languageObj?.id,
                                                    subMethod: 'label - from',
                                                })?.result}`}</b><br />
                                                {labels?.to?.[languageObj?.id]}: <b>{`${dateTimeFormatGlobalSet({
                                                    date: election?.endDate || new Date(),
                                                    type: languageObj?.format?.date?.f1,
                                                    format: 0,
                                                    addTime: true,
                                                    languageId: languageObj?.id,
                                                    subMethod: 'label - to',
                                                })?.result}`}</b><br />
                                                {labels?.status?.[languageObj?.id]}: <b>{statusByNumberGet({
                                                    status: election?.status || '',
                                                    languageId: languageObj?.id,
                                                    subMethod: currentMethod,
                                                })?.result}</b><br />
                                                {labels?.voteTwo?.[languageObj?.id]}: <b>
                                                    {!isUndNullEmp({ data: election?.executedVote, subMethod: 'label - voteTwo', })?.result && election?.executedVote ?
                                                        <span>
                                                            <i className={icons?.award}></i>
                                                            {HtmlParser(globalSettings?.html?.space?.formatOne)}{messages?.executed?.[languageObj?.id]}
                                                        </span>
                                                        :
                                                        <span>
                                                            <i className={icons?.fileAltFar}></i>
                                                            {HtmlParser(globalSettings?.html?.space?.formatOne)}{messages?.NotExecuted?.[languageObj?.id]}
                                                        </span>
                                                    }</b><br />
                                                {labels?.date?.[languageObj?.id]}: <b>{dateTimeFormatGlobalSet({
                                                    date: election?.executedVoteDate || new Date()?.toISOString(),
                                                    type: languageObj?.format?.date?.f1,
                                                    format: languageObj?.format?.time?.type,
                                                    addTime: false,
                                                    languageId: languageObj?.id,
                                                    subMethod: 'label - date',
                                                })?.result}</b><br />
                                            </address>
                                        </div>
                                        {/* /.col */}
                                        <div className='col-sm-4 invoice-col border-left'>
                                            {labels?.remark?.[languageObj?.id]}:<br />
                                            <b>{!isUndNullEmp({ data: election?.remark, subMethod: 'label - remark', })?.result ? HtmlParser(election?.remark?.replaceAll('\n', '<br/>')) : ''}</b>
                                        </div>
                                        {/* /.col */}
                                    </div>

                                    {/* /.row */}
                                    {/* Table row */}
                                    <div className='row'>
                                        <div className='col-12 table-responsive'>
                                            <table className='table table-sm table-bordered' style={{ fontSize: '13px' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '25%' }}>{labels?.name?.[languageObj?.id]}</th>
                                                        <th style={{ width: '10%' }} >{labels?.apartment?.[languageObj?.id]}</th>
                                                        <th style={{ width: '5%' }} className='text-center'>{labels?.votes?.[languageObj?.id]}</th>
                                                        <th style={{ width: '65%' }}></th>
                                                    </tr>
                                                </thead>
                                                {/* <tbody> */}
                                                {!isUndNullEmp({ data: electionDetails, subMethod: currentMethod, })?.result && electionDetails?.length > 0 ?
                                                    electionDetails?.map((detail, index) => (
                                                        (index === 0) || (index < electionDetails?.length && detail?.hierarchy !== electionDetails?.[index - 1]?.hierarchy) ?
                                                            <tbody key={dataDetailGet({ processType: 0, detail: detail, subMethod: 'table - name', })?.result}>
                                                                <tr key={index} style={{ backgroundColor: '#ddd', fontWeight: 'bold', }}>
                                                                    <th colSpan={4}>{dataDetailGet({ processType: 4, detail: detail, subMethod: 'table - key', })?.result}</th>
                                                                </tr>
                                                                {/* <tr key={dataDetailGet({ processType: 0, detail: detail, subMethod: 'table - name', })?.result}> */}
                                                                <tr>
                                                                    <td >{HtmlParser(globalSettings?.html?.space?.formatOne)}{dataDetailGet({ processType: 1, detail: detail, subMethod: 'table - apartment', })?.result}</td>
                                                                    <td >{dataDetailGet({ processType: 2, detail: detail, subMethod: 'table - votes', }).result}</td>
                                                                    <td className='text-center'>{dataDetailGet({ processType: 3, detail: detail, subMethod: 'table - space', })?.result}</td>
                                                                    <td style={{ verticalAlign: 'middle' }}>
                                                                        <div className='progress progress-sm active'>
                                                                            <div className='progress-bar bg-info progress-bar-striped' role='progressbar' aria-valuenow={dataDetailGet({ processType: 5, detail: detail, subMethod: 'table - progressbar', })?.result} aria-valuemin='0' aria-valuemax='100' style={{ width: `${dataDetailGet({ processType: 5, detail: detail, subMethod: 'table - td - 5', })?.result}%` }}>
                                                                                {/* <span className='sr-only'>40% Complete (success)</span> */}
                                                                                <span className=''><b>{dataDetailGet({ processType: 6, detail: detail, subMethod: 'table - td - 6', })?.result}%</b></span>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            :
                                                            <tbody key={dataDetailGet({ processType: 0, detail: detail, subMethod: 'table - tr - key' })?.result}>
                                                                {/* <tr key={dataDetailGet({ processType: 0, detail: detail, subMethod: 'table - tr - key' })?.result}> */}
                                                                <tr>
                                                                    <td >{HtmlParser(globalSettings?.html?.space?.formatOne)}{dataDetailGet({ processType: 1, detail: detail, subMethod: 'table - td - 1', })?.result}</td>
                                                                    <td >{dataDetailGet({ processType: 2, detail: detail, subMethod: 'table - td - 2', })?.result}</td>
                                                                    <td className='text-center'>{dataDetailGet({ processType: 3, detail: detail, subMethod: 'table - td - 3', })?.result}</td>
                                                                    <td style={{ verticalAlign: 'middle' }}>
                                                                        <div className='progress progress-sm active'>
                                                                            <div className='progress-bar bg-info progress-bar-striped' role='progressbar' aria-valuenow={dataDetailGet({ processType: 5, detail: detail, subMethod: 'table - td - 4', })?.result} aria-valuemin='0' aria-valuemax='100' style={{ width: `${dataDetailGet({ processType: 5, detail: detail, subMethod: 'table - td - 5', })?.result}%` }}>
                                                                                {/* <span className='sr-only'>40% Complete (success)</span> */}
                                                                                <span className=''><b>{dataDetailGet({ processType: 6, detail: detail, subMethod: 'table - td - 6', })?.result}%</b></span>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                    ))
                                                    :
                                                    <></>
                                                }
                                                {/* </tbody> */}
                                            </table>
                                        </div>
                                        {/* /.col */}
                                    </div>

                                    <hr />

                                    {/* /.row */}
                                    <div className='row'>
                                        {/* accepted payments column */}
                                        {/* <div className='col-6'>
                                            <p className='lead'>{labels?.paymentMethods?.[languageObj?.id]}:</p>
                                            <img className='mx-1 elevation-3' src={globalSettings?.images?.visaLogo} alt='visa' />
                                            <img className='elevation-3'src={globalSettings?.images?.masterCardLogo} alt='mastercard' />
                                            <img className='mx-1 elevation-3' src={globalSettings?.images?.americanExpressLogo} alt='americanExpress' />
                                            <img className='elevation-3'src={globalSettings?.images?.payPalLogo} alt='paypal' />
                                            <img className='mx-1 elevation-3' src={globalSettings?.images?.zelleLogo} alt='zelle' />
                                            <img className='elevation-3' src={globalSettings?.images?.bankTransferLogo} alt='bankTranfer' />
                                            <p className='text-muted well well-sm shadow-none' style={{marginTop: 10}}>
                                            </p>
                                        </div> */}
                                        {/* /.col */}
                                        {/* <div className='col-6'>
                                            <p className='lead'></p>
                                            <div className='table-responsive'>
                                                <table className='table table-sm'>
                                                    <tbody><tr>
                                                        <th style={{width: '50%'}}>{labels?.subTotal?.[languageObj?.id]}:</th>
                                                        <td className='text-right'>{separatorsNumbersSet(apartmentReceipt.total)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{labels?.tax.es} (0.00%):</th>
                                                        <td className='text-right'>0.00</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Total:</th>
                                                        <td className='text-right'>{apartmentReceipt.total}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> */}
                                        {/* /.col */}

                                        <div className='col-sm-3 col-6'>
                                            <div className='description-block border-right'>
                                                <span className='description-percentage text-primary'>
                                                    <i className={icons?.voteYea}></i>
                                                    {HtmlParser(globalSettings?.html?.space?.formatOne)}
                                                    {!isUndNullEmp({ data: electionDetails, subMethod: currentMethod, })?.result && electionDetails.length > 0 &&
                                                        !isUndNullEmp({ data: electionDetails?.[0]?.votesResults?.votesHierarchy, subMethod: 'label - votesHierarchy', })?.result ?
                                                        separatorsNumbersSet({
                                                            number: electionDetails?.[0]?.votesResults?.votesHierarchy,
                                                            withDecimals: false,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'label - votesHierarchy'
                                                        })?.result
                                                        :
                                                        separatorsNumbersSet({
                                                            number: 0,
                                                            withDecimals: false,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'label - votesHierarchy'
                                                        })?.result
                                                    }
                                                </span>
                                                <h5 className='description-header'>---</h5>
                                                <span className='description-text'>{labels?.totalVotes?.[languageObj?.id]}</span>
                                            </div>

                                        </div>

                                        <div className='col-sm-3 col-6'>
                                            <div className='description-block border-right'>
                                                <span className='description-percentage text-success'>
                                                    <i className={icons?.checkCircle}></i>
                                                    {HtmlParser(globalSettings?.html?.space?.formatOne)}
                                                    {/* {!isUndefined(electionDetails) && !isNull(electionDetails) && electionDetails.length > 0 &&
                                                        !isUndefined(electionDetails[0].votesResults) && !isNull(electionDetails[0].votesResults) &&
                                                        !isUndefined(electionDetails[0].votesResults.votesComplete) && !isNull(electionDetails[0].votesResults.votesComplete) ?
                                                        separatorsNumbersSet(electionDetails[0].votesResults.votesComplete).result :
                                                        separatorsNumbersSet(0).result
                                                    } */}
                                                    {!isUndNullEmp({ data: electionDetails, subMethod: currentMethod, })?.result && electionDetails.length > 0 &&
                                                        !isUndNullEmp({ data: electionDetails?.[0]?.votesResults?.votesComplete, subMethod: 'label - votesComplete', })?.result ?
                                                        separatorsNumbersSet({
                                                            number: electionDetails?.[0]?.votesResults?.votesComplete,
                                                            withDecimals: false,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'label - votesComplete'
                                                        })?.result
                                                        :
                                                        separatorsNumbersSet({
                                                            number: 0,
                                                            withDecimals: false,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'label - votesComplete'
                                                        })?.result
                                                    }
                                                </span>
                                                <h5 className='description-header'>---</h5>
                                                <span className='description-text'>{labels?.fullVotes?.[languageObj?.id]}</span>
                                            </div>

                                        </div>

                                        <div className='col-sm-3 col-6'>
                                            <div className='description-block border-right'>
                                                <span className='description-percentage text-warning'>
                                                    <i className={icons?.warningTrinagle}></i>
                                                    {HtmlParser(globalSettings?.html?.space?.formatOne)}
                                                    {/* {!isUndefined(electionDetails) && !isNull(electionDetails) && electionDetails.length > 0 &&
                                                        !isUndefined(electionDetails[0].votesResults) && !isNull(electionDetails[0].votesResults) &&
                                                        !isUndefined(electionDetails[0].votesResults.votesPartial) && !isNull(electionDetails[0].votesResults.votesPartial) ?
                                                        separatorsNumbersSet(electionDetails[0].votesResults.votesPartial).result :
                                                        separatorsNumbersSet(0).result
                                                    } */}
                                                    {!isUndNullEmp({ data: electionDetails, subMethod: currentMethod, })?.result && electionDetails.length > 0 &&
                                                        !isUndNullEmp({ data: electionDetails?.[0]?.votesResults?.votesPartial, subMethod: 'label - votesPartial', })?.result ?
                                                        separatorsNumbersSet({
                                                            number: electionDetails?.[0]?.votesResults?.votesPartial,
                                                            withDecimals: false,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'label - votesPartial'
                                                        })?.result
                                                        :
                                                        separatorsNumbersSet({
                                                            number: 0,
                                                            withDecimals: false,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'label - votesPartial'
                                                        })?.result
                                                    }
                                                </span>
                                                <h5 className='description-header'>---</h5>
                                                <span className='description-text'>{labels?.partialVotes?.[languageObj?.id]}</span>
                                            </div>

                                        </div>

                                        <div className='col-sm-3 col-6'>
                                            <div className='description-block'>
                                                <span className='description-percentage text-secondary'>
                                                    <i className={icons?.stickyNote}></i>
                                                    {HtmlParser(globalSettings?.html?.space?.formatOne)}
                                                    {/* {!isUndefined(electionDetails) && !isNull(electionDetails) && electionDetails.length > 0 &&
                                                        !isUndefined(electionDetails[0].votesResults) && !isNull(electionDetails[0].votesResults) &&
                                                        !isUndefined(electionDetails[0].votesResults.votesNull) && !isNull(electionDetails[0].votesResults.votesNull) ?
                                                        separatorsNumbersSet(electionDetails[0].votesResults.votesNull).result :
                                                        separatorsNumbersSet(0).result
                                                    } */}
                                                    {!isUndNullEmp({ data: electionDetails, subMethod: currentMethod, })?.result && electionDetails.length > 0 &&
                                                        !isUndNullEmp({ data: electionDetails?.[0]?.votesResults?.votesNull, subMethod: 'label - votesNull', })?.result ?
                                                        separatorsNumbersSet({
                                                            number: electionDetails?.[0]?.votesResults?.votesNull,
                                                            withDecimals: false,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'label - votesNull'
                                                        })?.result
                                                        :
                                                        separatorsNumbersSet({
                                                            number: 0,
                                                            withDecimals: false,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'label - votesNull'
                                                        })?.result
                                                    }
                                                </span>
                                                <h5 className='description-header'>---</h5>
                                                <span className='description-text'>{labels?.invalidVotes?.[languageObj?.id]}</span>
                                            </div>

                                        </div>
                                    </div>
                                    {/* /.row */}

                                    <div className='row'>
                                        <div className='col-12'>
                                            <hr style={{ height: '0.5' }} />
                                        </div>
                                    </div>

                                    <div className='row text-center' style={{ fontSize: 12 }}>
                                        <div className='col-sm-3 text-muted'>
                                            {`${globalSettings?.app?.company?.name} `}
                                        </div>
                                        <div className='col-sm-3 text-muted'>
                                            {`${globalSettings?.app?.company?.slogan}`}
                                        </div>
                                        <div className='col-sm-3 text-muted'>
                                            {`${globalSettings?.app?.company?.url}`}
                                        </div>
                                        <div className='col-sm-3 text-muted'>
                                            {`${globalSettings?.app?.name} / ${globalSettings?.app?.version} / ${globalSettings?.app?.year}`}
                                        </div>
                                    </div>

                                </section>

                            </div>
                        </div>
                    </div>
                    :
                    //#region old code
                    // <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                    //     width={50}
                    //     height={50}
                    //     color={globalSettings?.colors?.infoColorExp}
                    //     msgText={messages?.processing?.[languageObj?.id]}
                    //     msgOrientation='text-center'
                    //     msgTextMuted={true}/>
                    //#endregion old code
                    <div className='text-center'
                        style={{ paddingTop: '50px', }}>
                        <LoadingSection alt='loadingSection'
                            className={globalSettings?.react?.html?.overlay?.textMued}
                            //className='overlay text-muted'
                            showText={true}
                            text={messages?.processing?.[languageObj?.id]}
                            height={25}
                            hidden={!showLoading}
                            languageId={languageObj?.id}
                            width={25}
                            subMethod={currentMethod} />
                    </div>
                //#region old code
                // <div hidden={!showLoading}>
                //     <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                //         width={50}
                //         height={50}
                //         color={globalSettings?.colors?.infoColorExp}
                //         msgText={messages?.processing?.[languageObj?.id]}
                //         msgOrientation='text-center'
                //         msgTextMuted={true}
                //     />
                // </div>
                //#endregion old code
            }

            {/* </div> */}
        </div>
    )
}